const SAVE_SCROLL_POSITION = 'SAVE_SCROLL_POSITION';

export const saveScrollPosition = (routeKey, scrollTop) => ({
  type: SAVE_SCROLL_POSITION,
  payload: { routeKey, scrollTop }
});

const initialState = {};

export default function scroll(state = initialState, action) {
  switch (action.type) {
    case SAVE_SCROLL_POSITION:
      return {
        ...state,
        [action.payload.routeKey]: action.payload.scrollTop
      };
    default:
      return state;
  }
}
